import React, { useEffect, useState } from 'react'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/styles/table-style'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'

const StageServicesTable:React.FC = () => {
  const [services, setServices] = useState<any[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    const getServices = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVICES_BASE_URL}/service-stage`)
        if(response.data) setServices(response.data)
      } catch (error) {
        console.error(error)
      }
    }
    getServices()
  }, [])
  
  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          <Th>Código</Th>
          <Th>Serviço</Th>
          <Th>Categoria</Th>
          <Th>Tipo</Th>
          <Th>Preço/un</Th>
          <Th>Prazo</Th>
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {services.map((service, index) => (
          <Tr key={index}>
            <Td>{service.id}</Td>
            <Td>{service.name}</Td>
            <Td>{service.category}</Td>
            <Td>{service.type}</Td>
            <Td>{service.pricePerUnit}</Td>
            <Td>{service.deadlineInDays}</Td>
            <TdButtons>
              <img src={lookup} alt='looup-icon' onClick={() => navigate(`view/?id=${service.id}`)} />
            </TdButtons>
          </Tr>
        ))}
      </tbody>
    </GlobalTable>  
    )
}

export default StageServicesTable